import React from 'react';
import { Link } from '@naf-simba/elements-links';
import { Typography } from '@naf-simba/building-blocks-typography';
import BlockContent from '@components/block-content/BlockContent';
import { useAuth0Token } from '../../../hooks/useAuth0Token';
import { useDocumentData } from '../../../hooks/Documents/useDocumentData';
import { ArticleType } from '../../../../../types/articleType';
import { CompetitionStyleVariant } from '../Competition.types';

const TERMS_TEXT = {
  close: 'Lukk',
  error: 'Kunne ikke laste vilkår.',
  loading: 'Laster vilkår...',
};

interface CompetitionTermsAndConditionsProps {
  style: CompetitionStyleVariant;
  termsLinkSlug: string;
  onHideTerms: () => void;
}

const CompetitionTermsAndConditions = ({ style, termsLinkSlug, onHideTerms }: CompetitionTermsAndConditionsProps) => {
  const { simpleToken } = useAuth0Token();
  const { meta, data: termsData } = useDocumentData(termsLinkSlug, simpleToken);
  const body = (termsData as ArticleType | undefined)?.body;
  const isInverted = style === 'spruce';
  const isLoadingTerms = !body && meta.isUpdating;
  const hasTermsError = !body && meta.isUpdating === false;

  return (
    <>
      {body ? <BlockContent value={body} /> : null}
      {isLoadingTerms ? <Typography variant="textMRegular">{TERMS_TEXT.loading}</Typography> : null}
      {hasTermsError ? <Typography variant="textMRegular">{TERMS_TEXT.error}</Typography> : null}
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid -- Link used as a non-navigating action */}
      <Link onClick={onHideTerms} text={TERMS_TEXT.close} inverted={isInverted} />
    </>
  );
};

export default CompetitionTermsAndConditions;
